import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useStore } from 'zustand';
import { createProtocolStore, ProtocolState, ProtocolStore } from './protocolStore.ts';


const ProtocolContext = createContext<ProtocolStore | null>(null);

export function ProtocolStoreProvider({ children }: { children: ReactNode }) {
    const store = useMemo(() => createProtocolStore(), []);

    return (
        <ProtocolContext.Provider value={store}>
            {children}
        </ProtocolContext.Provider>
    );
}


// eslint-disable-next-line react-refresh/only-export-components
export function useProtocolStore<T>(selector: (s: ProtocolState) => T): T {
    const store = useContext(ProtocolContext);
    if (!store) throw new Error('Missing CounterProvider');
    return useStore(store, selector);
}

// eslint-disable-next-line react-refresh/only-export-components
export function useProtocolStoreObj(): ProtocolStore {
    const store = useContext(ProtocolContext);
    if (!store) throw new Error('Missing CounterProvider');
    return store;
}
